import axios from '../axios/redditlikeApi'

const validateUpdateEmailAddressToken = uuid => axios.get(`/email-address/${uuid}`)

const sendUpdateEmailAddressLink = reqBody => axios.post('/email-address/send-update-verification', reqBody)

const updateEmailAddress = uuid => axios.patch(`/email-address/update/${uuid}`)

export default {
  validateUpdateEmailAddressToken,
  sendUpdateEmailAddressLink,
  updateEmailAddress
}
